import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// PrimeNG Modules
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MultiSelectModule } from 'primeng/multiselect';
import { DialogModule } from 'primeng/dialog';
import { TabsModule } from 'primeng/tabs';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { TooltipModule } from 'primeng/tooltip';
import { ToastModule } from 'primeng/toast';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { CardModule } from 'primeng/card';
import { MenuModule } from 'primeng/menu';
import { CheckboxModule } from 'primeng/checkbox';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { ChartModule } from 'primeng/chart';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { TabViewModule } from 'primeng/tabview';
import { EditorModule } from 'primeng/editor';
import { DividerModule } from "primeng/divider";

const PRIMENG_MODULES = [
  ButtonModule,
  InputTextModule,
  DropdownModule,
  CalendarModule,
  MultiSelectModule,
  DialogModule,
  TabsModule,
  TableModule,
  PaginatorModule,
  IconFieldModule,
  InputIconModule,
  TooltipModule,
  ToastModule,
  ProgressSpinnerModule,
  CardModule,
  MenuModule,
  CheckboxModule,
  ToolbarModule,
  PanelModule,
  ChartModule,
  ConfirmDialogModule,
  OverlayPanelModule,
  TabViewModule,
  EditorModule,
  DividerModule
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ...PRIMENG_MODULES
  ],
  exports: [
    ...PRIMENG_MODULES
  ]
})
export class PrimeNGSharedModule { }